import { Box, EmptyCell, Typography } from 'shared/ui'
import { type IColumn } from 'shared/ui/TableNew'
import { uiStore } from 'shared/store/uiStore'
import { DayjsFormats } from 'shared/lib'
import { type RowPendingClient } from 'entities/Clients/model/RowPendingClient'

export const pendingClientsColumns: IColumn<RowPendingClient>[] = [
  {
    field: 'email',
    name: 'Email',
    isSortable: true,
    sortKey: 'email',
    width: '50%',
    renderRowCell: (row) => EmailCell(row.email),
  },
  {
    field: 'created_at',
    name: 'Sent',
    isSortable: true,
    sortKey: 'created_at',
    renderRowCell: (row) =>
      row.createdAt ? (
        <Typography variant='body-md-regular' ariaLabel='createdAt'>
          {uiStore.dayjs(row.createdAt).format(DayjsFormats.full6)}
        </Typography>
      ) : (
        <EmptyCell />
      ),
  },
]

const EmailCell = (value: string) => {
  return value ? (
    <Box display='flex'>
      <Typography
        variant={'body-md-regular'}
        ellipsis
        ariaLabel={`EmailCell_${value}`}
        tooltipProps={{
          label: value,
        }}
      >
        {value}
      </Typography>
    </Box>
  ) : (
    <EmptyCell />
  )
}
